import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import Toggle from 'react-toggle';
import { Modal } from 'react-bootstrap';

class StaffDesignationRevisionModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      staff_designation: {},
      designation_responsibles: {},
      required: 0,
    };
    this.sendEmail = this.sendEmail.bind(this);
  }

  // Handlers
  handleToggleChange (name, event) {
    var change = {};
    var data_temp = [];
    var self = this;
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }

    Object.keys(self.state.designation_responsibles).map(function(k) {
      if(self.state.designation_responsibles[k].id === name) {
        change = {
          required: value,
          status: self.state.designation_responsibles[k].status,
          staff_revision_id: self.state.designation_responsibles[k].staff_revision_id,
          staff_revision_designation_id: self.state.designation_responsibles[k].staff_revision_designation_id,
          staff_designation_id: self.state.designation_responsibles[k].staff_designation_id,
          designation_id: self.state.designation_responsibles[k].designation_id,
          designation_responsible_id: self.state.designation_responsibles[k].designation_responsible_id,
          name: self.state.designation_responsibles[k].name,
          document_id: self.state.designation_responsibles[k].document_id,
          id: self.state.designation_responsibles[k].id,
          designation_responsible: self.state.designation_responsibles[k].designation_responsible,
          designation: self.state.designation_responsibles[k].designation,
          staff_revision_designation: self.state.designation_responsibles[k].staff_revision_designation,
          staff_revision: self.state.designation_responsibles[k].staff_revision,
        };
      } else {
        change = {
          required: self.state.designation_responsibles[k].required,
          status: self.state.designation_responsibles[k].status,
          staff_revision_id: self.state.designation_responsibles[k].staff_revision_id,
          staff_revision_designation_id: self.state.designation_responsibles[k].staff_revision_designation_id,
          staff_designation_id: self.state.designation_responsibles[k].staff_designation_id,
          designation_id: self.state.designation_responsibles[k].designation_id,
          designation_responsible_id: self.state.designation_responsibles[k].designation_responsible_id,
          name: self.state.designation_responsibles[k].name,
          document_id: self.state.designation_responsibles[k].document_id,
          document_id: self.state.designation_responsibles[k].document_id,
          id: self.state.designation_responsibles[k].id,
          designation_responsible: self.state.designation_responsibles[k].designation_responsible,
          designation: self.state.designation_responsibles[k].designation,
          staff_revision_designation: self.state.designation_responsibles[k].staff_revision_designation,
          staff_revision: self.state.designation_responsibles[k].staff_revision,
        };
      }
      data_temp.push(change);
    });
    this.setState({designation_responsibles: data_temp});
  }
  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.designation_responsibles)) {
      this.setState({
        designation_responsibles: newProps.designation_responsibles,
      });
    }
    this.setState({modal: newProps.modal});
  }

  sendEmail(event) {
    var confirm = window.confirm('Tem certeza que gostaria de enviar os emails de finalização de designação?');
    if (confirm) {
      var self = this;
      self.props.modalPropsOff();
      this.props.handleAlert('', '', 'open');
      var datasave = {
        staff_revision_designation_responsibles: this.state.designation_responsibles,
      };
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api_sigmec') + '/colaborador/revisao/designacao/email/finalizacao', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.refreshData(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <Modal show={self.state.modal} aria-labelledby="contained-modal-alert-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">Revisão {self.state.staff_designation.number}</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={this.props.modalPropsOff}><i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <div>
        <table className="table table-bordered table-stripped table-hover">
          <thead>
            <tr>
              <th className="text-center">Nome do Colaborador</th>
              <th className="text-center">Designação</th>
              <th className="text-center">Selecionar</th>
            </tr>
          </thead>
          <tbody id="suppliers-certifications">
            {Object.keys(self.state.designation_responsibles).map(function(k) {
              return (
                <tr>
                  <td className="text-center">{self.state.designation_responsibles[k].designation_responsible.staff.name}</td>
                  <td className="text-center">{self.state.designation_responsibles[k].designation.name}</td>
                  <td className="text-center">
                    <Toggle
                      checked={self.state.designation_responsibles[k].required}
                      disabled={self.state.designation_responsibles[k].staff_revision_designation.status !== 'pendente' ?
                      "disabled"
                      : ""
                      }
                      name={self.state.designation_responsibles[k].id}
                      onChange={self.handleToggleChange.bind(self, self.state.designation_responsibles[k].id)} />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <hr/>
        <button className="btn btn-lg btn-primary btn-block" value={'ii'} onClick={self.sendEmail}><i className="fa fa-fw fa-email"></i> Solicitar Aprovações</button>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={this.props.modalPropsOff}><i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
</div>
    );
  }
}

export default StaffDesignationRevisionModal;



// WEBPACK FOOTER //
// ./src/Components/SigmecStaffs/Elements/StaffDesignationRevisionModal.js